<template>
  <error-boundary module="before-print-editing">
    <div class="before-print-editing-module">
      <au-tfn v-model:value="localDocument"></au-tfn>
    </div>
  </error-boundary>
</template>

<script>
import { computed } from 'vue';
import store from '@/store';
import AuTfn from '@/components/document-before-print-au-tfn.vue';
import ErrorBoundary from '@/components/error-boundary.vue';

export default {
  name: 'before-print-editing-module',
  components: { ErrorBoundary, AuTfn },
  setup() {
    const documents = computed(() => store.state.documents);
    const onboarding = computed(() => store.state.onboarding);
    const employee = computed(() => store.state.Employee.employee);

    const localDocument = {
      documents: documents.value,
      onboarding: onboarding.value,
      email: employee.value.email,
    };
    return {
      localDocument,
    };
  },
};
</script>

<style scoped lang="scss">
@media print {
  .no-print {
    display: none;
  }
}
</style>
